import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeatureSection from "./components/FeatureSection";
import ComparisonSection from "./components/ComparisonSection";
import ArticleSection from "./components/ArticleSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";
import { buildHomeJsonLd } from "@/mocks/seoMetadata";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={buildHomeJsonLd()} />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <FeatureSection />
      <ComparisonSection />
      <ArticleSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}